import { extendSemantics, SemanticsExtended } from '@veneer/core';
import { primitives } from '@veneer/primitives';
import { GlobalsStyles } from '@monetization/hpaip-components-library';

const {
  color: {
    gray2,
    gray3,
    gray5,
    gray6,
    gray7,
    gray12,
    hpBlue7,
    hpBlue8,
    royalBlue7,
    white,
    black,
  },
} = GlobalsStyles;

export const defaultTheme = extendSemantics({
  color: {
    light: {
      neutral: {
        base: {
          default: gray7,
        },
      },
      primary: {
        base: {
          default: gray12,
          hover: gray12,
          active: gray12,
        },
        background: {
          default: gray12,
          hover: gray12,
          active: 'rgba(163,163,163,0.2)',
        },
      },
      background: {
        disabled: gray5,
      },
      foreground: {
        disabled: white,
      },
      focus: {
        default: 'rgba(163,163,163,0)',
        inverse: 'rgba(163,163,163,0)',
      },
    },
  },
});

export const secondaryTheme = extendSemantics({
  shape: 'sharp',
  color: {
    light: {
      neutral: {
        base: {
          default: white,
        },
      },
      primary: {
        base: {
          default: gray12,
          hover: gray12,
          active: gray12,
        },
        background: {
          default: white,
          hover: gray2,
          active: gray3,
        },
      },
      background: {
        disabled: gray3,
      },
      foreground: {
        disabled: gray3,
      },
      focus: {
        default: 'rgba(163,163,163,0)',
        inverse: 'rgba(163,163,163,0)',
      },
    },
  },
});

export const cartAfuTheme = extendSemantics({
  color: {
    light: {
      neutral: {
        base: {
          default: gray6,
        },
      },
      primary: {
        base: {
          default: hpBlue7,
          hover: hpBlue7,
        },
      },
    },
  },
});

export const reviewSubscriptionCardTheme = extendSemantics({
  color: {
    light: {
      primary: {
        base: {
          default: black,
          hover: black,
        },
      },
    },
  },
});

export const accessoryCardTheme = extendSemantics({
  shape: 'round',
  color: {
    light: {
      neutral: {
        base: {
          default: gray6,
        },
      },
      primary: {
        base: {
          default: royalBlue7,
          hover: royalBlue7,
        },
      },
    },
  },
});

export const checkBoxTheme = extendSemantics({
  shape: 'round',
  color: {
    light: {
      neutral: {
        base: {
          default: gray6,
        },
      },
      primary: {
        base: {
          default: hpBlue7,
          hover: hpBlue8,
          active: '#024466',
        },
      },
    },
  },
});

export const defaultThemeV2 = extendSemantics({
  color: {
    light: {
      neutral: {
        base: {
          default: primitives.color.gray7,
        },
      },
      primary: {
        base: {
          default: primitives.color.electricBlue7,
          hover: primitives.color.electricBlue8,
          active: primitives.color.electricBlue9,
        },
        background: {
          default: primitives.color.electricBlue7,
          hover: primitives.color.electricBlue7,
          active: 'rgba(163,163,163,0.2)',
        },
      },
      background: {
        disabled: primitives.color.gray3,
      },
      foreground: {
        disabled: primitives.color.gray7,
      },
      focus: {
        default: primitives.color.gray5,
        inverse: 'rgba(163,163,163,0)',
      },
    },
    dark: {
      neutral: {
        base: {
          default: primitives.color.white,
        },
      },

      primary: {
        base: {
          default: primitives.color.gray12,
          hover: primitives.color.red9,
          active: primitives.color.gray8,
        },
        background: {
          default: primitives.color.white,
          hover: primitives.color.gray2,
          active: primitives.color.gray3,
        },
        foreground: {
          default: primitives.color.white,
          hover: primitives.color.white,
          active: primitives.color.white,
        },
      },
      background: {
        disabled: primitives.color.gray3,
      },
      foreground: {
        disabled: primitives.color.gray7,
      },
      focus: {
        default: 'rgba(163,163,163,0)',
        inverse: 'rgba(163,163,163,0)',
      },
    },
  },
});

export const secondaryThemeV2 = extendSemantics({
  shape: 'round',
  color: {
    light: {
      neutral: {
        base: {
          default: primitives.color.white,
        },
      },
      primary: {
        base: {
          default: primitives.color.electricBlue7,
          hover: primitives.color.electricBlue8,
          active: primitives.color.electricBlue9,
        },
        background: {
          default: primitives.color.gray1,
          hover: primitives.color.electricBlue1,
          active: primitives.color.electricBlue2,
        },
      },
      background: {
        disabled: primitives.color.gray3,
      },
      foreground: {
        disabled: primitives.color.gray3,
      },
      focus: {
        default: 'rgba(163,163,163,0)',
        inverse: 'rgba(163,163,163,0)',
      },
    },
  },
});

export const themes: { [key: string]: SemanticsExtended } = {
  defaultTheme,
  defaultThemeV2,
  secondaryTheme,
  secondaryThemeV2,
  cartAfuTheme,
  reviewSubscriptionCardTheme,
  accessoryCardTheme,
  checkBoxTheme,
};
